import { render, staticRenderFns } from "./SalesOrderTable.vue?vue&type=template&id=05791ed6&scoped=true"
import script from "./SalesOrderTable.vue?vue&type=script&lang=js"
export * from "./SalesOrderTable.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderTable.vue?vue&type=style&index=0&id=05791ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05791ed6",
  null
  
)

export default component.exports